var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { getAll, update } from '../../api/warehouseItem';
import { column, useWarehouseItemColumns } from '../../hooks/useColumns';
import { useRequest } from '../../hooks/requestHook';
import useFetch from '../../hooks/useFetch';
import MaterialTable from '../MaterialTable';
import { decamelize } from '../../utils/camelize';
import { orange, red } from '@mui/material/colors';
import { differenceInMonths, endOfDay, isPast, startOfDay } from 'date-fns';
import { useNotify } from '../../hooks/notificationHook';
import { useOffice } from '../../hooks/useOffice';
import { toOptions, useOrderListItem } from '../../hooks/useListItem';
import PageLayout from '../atoms/PageLayout';
import DownloadButton from '../molecules/DownloadButton';
export var warehouseItemRowStyle = function (data) {
    var endOfStoragePeriod = new Date(data.endOfStoragePeriod);
    if (isPast(endOfStoragePeriod))
        return { backgroundColor: red[50] };
    var remainingMonths = differenceInMonths(endOfStoragePeriod, new Date());
    if (remainingMonths >= 2)
        return {};
    return { backgroundColor: orange[50] };
};
var AdminWarehouseItemsPage = function () {
    var t = useTranslation().t;
    var location = useLocation();
    var WarehouseItemColumns = useWarehouseItemColumns({ role: 'admin' });
    var getAllApi = useRequest(getAll);
    var updateApi = useRequest(update);
    var notify = useNotify();
    var officeListItems = useOffice().officeListItems;
    var urlQuery = qs.parse(location.search.slice(1));
    var initialPage = parseInt((urlQuery.page || '')) || 0;
    var pageSize = parseInt((urlQuery.pageSize || '')) || 25;
    var paymentTimingFilterItems = useOrderListItem().paymentTimingFilterItems;
    var defaultFilter = React.useCallback(function (field) {
        var filters = urlQuery.filters || {};
        return filters[field];
    }, [urlQuery]);
    var columns = React.useMemo(function () { return [
        __assign(__assign({}, WarehouseItemColumns.id), { defaultFilter: defaultFilter('id') }),
        __assign(__assign({}, WarehouseItemColumns.offerListLink), { defaultFilter: defaultFilter('offer.offerList.name') }),
        __assign(__assign({}, WarehouseItemColumns.lotNumber), { defaultFilter: defaultFilter('offer.lotNumber') }),
        __assign(__assign({}, WarehouseItemColumns.orderLink), { defaultFilter: defaultFilter('order.id') }),
        __assign(__assign({}, WarehouseItemColumns.warehouse), { defaultFilter: defaultFilter('warehouse.name') }),
        column('warehouse.office.id', {
            title: t('params.office.name'),
            defaultFilter: defaultFilter('warehouse.office.id'),
            lookup: toOptions(officeListItems),
            sorting: false,
            editable: 'never',
        }),
        __assign(__assign({}, WarehouseItemColumns.roaster), { sorting: false, defaultFilter: defaultFilter('order.roaster') }),
        __assign(__assign({}, WarehouseItemColumns.total), { filtering: false }),
        __assign(__assign({}, WarehouseItemColumns.remainingQuantity), { filtering: true, defaultFilter: defaultFilter('remainingQuantity') }),
        __assign(__assign({}, WarehouseItemColumns.deliveredQuantity), { filtering: false }),
        __assign(__assign({}, WarehouseItemColumns.isTypicaSelection), { defaultFilter: defaultFilter('isTypicaSelection'), sorting: false }),
        __assign(__assign({}, WarehouseItemColumns.paymentTiming), { filtering: true, sorting: false, lookup: toOptions(paymentTimingFilterItems), defaultFilter: defaultFilter('order.paymentTiming') }),
        __assign(__assign({}, WarehouseItemColumns.exportedAt), { defaultFilter: defaultFilter('exportedAt') }),
        __assign(__assign({}, WarehouseItemColumns.importedAt), { defaultFilter: defaultFilter('importedAt') }),
        __assign(__assign({}, WarehouseItemColumns.endOfStoragePeriod), { defaultFilter: defaultFilter('endOfStoragePeriod') }),
    ]; }, [
        t,
        defaultFilter,
        WarehouseItemColumns,
        officeListItems,
        paymentTimingFilterItems,
    ]);
    var buildFilterParams = React.useCallback(function (query) {
        var q = {};
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'id':
                    q['id_eq'] = filter.value;
                    break;
                case 'order.id':
                    q['order_id_eq'] = filter.value;
                    break;
                case 'remainingQuantity':
                    if (filter.value == 'inStock')
                        q.remaining = true;
                    break;
                case 'isTypicaSelection':
                    q.order_type_eq =
                        filter.value === 'checked'
                            ? 'Order::TypicaStockOrder'
                            : 'Order::DirectOrder';
                    break;
                case 'order.roaster':
                    q.order_roaster_id_eq = filter.value;
                    break;
                case 'importedAt':
                case 'exportedAt':
                case 'endOfStoragePeriod': {
                    var field = decamelize(filter.column.field);
                    if (filter.value.startedAt) {
                        q["".concat(field, "_gteq")] = startOfDay(new Date(filter.value.startedAt));
                    }
                    if (filter.value.endedAt) {
                        q["".concat(field, "_lteq")] = endOfDay(new Date(filter.value.endedAt));
                    }
                    break;
                }
                case 'warehouse.office.id':
                    q['with_office'] = filter.value;
                    break;
                case 'order.paymentTiming':
                    q.with_payment_timing = filter.value;
                    break;
                default:
                    if (filter.column.field) {
                        var field = filter.column.field
                            .split('.')
                            .map(function (e) { return decamelize(e); })
                            .join('_');
                        q["".concat(field, "_cont")] = filter.value;
                    }
                    break;
            }
        });
        return q;
    }, []);
    var buildOrder = React.useCallback(function (order) {
        switch (order) {
            case 'offer.lotNumber':
                return 'offers.lot_number';
            case 'orderItem.order.roaster.company':
                return 'roasters.company';
            case 'orderItem.order.roaster.storeName':
                return 'roasters.store_name';
            case 'orderItem.order.roaster.lastname':
                return 'roasters.lastname';
            case 'orderItem.order.roaster.firstname':
                return 'roasters.firstname';
            case 'orderItem.order.paymentTimings':
                return 'orders.paymentTimings';
            case 'warehouse.name':
                return 'warehouses.name';
            default:
                return decamelize(order);
        }
    }, []);
    var fetchWarehouseItems = useFetch({
        buildFilterParams: buildFilterParams,
        api: getAllApi,
        buildOrder: buildOrder,
    });
    var handleUpdate = React.useCallback(function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateApi({
                        id: item.id,
                        warehouse_item: {
                            imported_at: item.importedAt,
                            exported_at: item.exportedAt,
                            end_of_storage_period: item.endOfStoragePeriod,
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        throw Error('response error');
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, notify, updateApi]);
    var csvParams = React.useMemo(function () {
        if (!urlQuery.filters)
            return;
        var filters = Object.entries(urlQuery.filters).map(function (_a) {
            var field = _a[0], value = _a[1];
            return ({
                column: { field: field },
                operator: '=',
                value: value,
            });
        });
        return { q: buildFilterParams({ filters: filters }) };
    }, [urlQuery.filters, buildFilterParams]);
    return (React.createElement(PageLayout, { title: t('pages.warehouseItems.title'), actions: React.createElement(DownloadButton, { key: JSON.stringify(csvParams), size: "medium", path: "/api/warehouse_items/export", downloadFilename: "warehouse_items.csv", params: csvParams, withDownloadTimestamp: true }) },
        React.createElement(MaterialTable, { model: "warehouseItem", columns: columns, data: fetchWarehouseItems, options: {
                filtering: true,
                filterCellStyle: {
                    minWidth: 100,
                    maxWidth: 200,
                },
                paging: true,
                initialPage: initialPage,
                pageSize: pageSize,
                rowStyle: warehouseItemRowStyle,
            }, editable: {
                onRowUpdate: handleUpdate,
            } })));
};
export default AdminWarehouseItemsPage;
